import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        "detail",
        "convictionDetail",
        "fileInput",
        "fileLabel"
    ];

    static values = {
        hasDbs: String,
        hasConvictions: String
    };

    connect() {
        this.toggleSection(this.detailTarget, this.isTrue(this.hasDbsValue));
        this.toggleSection(this.convictionDetailTarget, this.isTrue(this.hasConvictionsValue));
    }

    showDetail(event) {
        this.toggleSection(this.detailTarget, event.target.value === "true");
    }

    showConvictionDetail(event) {
        this.toggleSection(this.convictionDetailTarget, event.target.value === "true");
    }

    updateFileName() {
        if (!this.hasFileInputTarget || !this.hasFileLabelTarget) return;

        const file = this.fileInputTarget.files && this.fileInputTarget.files[0];
        this.fileLabelTarget.textContent = file ? file.name : "Upload DBS Certificate";
    }

    toggleSection(element, show) {
        if (!element) return;

        if (show) {
            element.classList.remove("hidden");
        } else {
            element.classList.add("hidden");
        }
    }

    isTrue(value) {
        return String(value) === "true";
    }
}